<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    isShowDetail ||
    isShowSendBulkDetail ||
    isShowResendByDeliveryStatus ||
    isShowPhonebookRecipient ||
    isShowSendSmartDetail ||
    isShowResendDetail
      ? 'd-none'
      : ''
  "
  [config]="pageConfig"
  (onAdd)="goSendSmsPage('sendSMS')"
  [id]="tabName"
  (sortObject)="getSortItems($event)"
  (onShowHelpPage)="onShowHelpPage()"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onSelectAll)="onSelectAll($event)"
  [defaultFilters]="defaultFilters"
  [ignoreDisableBtn]="true"
>
  <!---------------------------------------- btns --------------------------------------->
  <div class="card-toolbar" before-btns>
    <!--organization-->
    <div class="tw-w-[300px]" *ngIf="isShowOrganizationSearch">
      <organization-select-search
        type="descendantList"
        [(value)]="organizationId"
        (valueChange)="onChangeOrganization($event)"
      >
      </organization-select-search>
    </div>

    <!-- ResendScheduledMessage btn -->
    <div [matTooltip]="'common.resendSMS' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupResend()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-email-sync mdi-20px tw-p-0 text-success"></i>
      </button>
    </div>

    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        *ngIf="userSession.organizationId() == 1"
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>

    <!-- advanced search btn -->
    <button
      (click)="onAdvanceSearch()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="pageVocabs + 'advancedSearch.title' | translate"
    >
      <i class="mdi mdi-magnify mdi-20px tw-p-0 text-navyBlue"></i>
    </button>

    <!-- excel btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcel' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>

    <!-- excel with more detail btn -->
    <button
      [disabled]="(items$ | async)?.length == 0"
      (click)="onExcelWithMoreDetailReport()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.downloadExcelWithMoreDetail' | translate"
    >
      <i class="mdi mdi-download mdi-20px tw-p-0 text-info"></i>
    </button>
  </div>
  <!--------------------------------------- Table Content --------------------------------------->

  @let cols= tableColumns;

  <ng-container table-body *ngIf="items$ | async">
    @for(item of items$ | async; track item?.scheduledMessageId;let i = $index){
    <tr
      #row
      (click)="onActiveRow(row, i)"
      [class.row-active]="rowIndexSelected == i"
      [class.tds-preloading]="pageConfig.loading"
      [class.tw-hidden]="pageConfig.loading"
      [ngClass]="
        userSession.organizationId() == 1 && item?.isShouldNotResend
          ? 'tr-expired'
          : ''
      "
    >
      <!-- index -->
      <td
        class="tw-px-2 tw-text-center tw-text-sm sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
      >
        {{ paginationModel?.firstIndex + i }}
        <i
          *ngIf="item.isFirstPartOfGradualOrPeriodic"
          class="mdi mdi-numeric-1-box mdi-20px text-info"
        ></i>
      </td>

      <!-- checkbox -->
      <td
        class="sticky-item tw-px-2 lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'right'"
      >
        <div class="form-check tw-text-center">
          <input
            type="checkbox"
            class="form-check-input tw-mt-[1px] tw-mr-0"
            (click)="onAddSelectedId($event, item.scheduledMessageId, row)"
            [attr.data-checkbox-id]="item.scheduledMessageId"
          />
        </div>
      </td>

      <!-- scheduledMessageId -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.scheduledMessageId : tagName)?.isHide
        "
        [attr.order]="
          (cols | columnData : columnNames.scheduledMessageId : tagName)?.order
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.scheduledMessageId : tagName)
                ?.size + 'px'
            : null
        "
        [attr.name]="columnNames.scheduledMessageId"
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8] tw-px-1"
        [attr.position]="'right'"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.scheduledMessageId : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            [value]="item?.scheduledMessageId"
          ></td-value>
        </div>
      </td>

      <!-- smsText -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.smsText : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.smsText : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.smsText"
        [attr.order]="
          (cols | columnData : columnNames.smsText : tagName)?.order
        "
        class="msg-summary sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8] msg-summary tw-text-center"
        [attr.position]="'right'"
        [ngClass]="{
          ' tw-cursor-pointer': item?.smsText
        }"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.smsText : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <div
            class="tw-flex-center"
            textPopover
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
            [parentSelector]="tagName"
            [fullText]="item?.smsText"
          >
            <p
              (click)="
                item?.voiceMessageId
                  ? getShortcutDetailModelApi(
                      item?.smsText,
                      item?.voiceMessageId
                    )
                  : ''
              "
              [ngClass]="item?.voiceMessageId ? 'hover:tw-text-blue-700' : ''"
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px] font-vazir-ui"
              [style.width]="
                innerWidth > 1024
                  ? (cols | columnData : columnNames.smsText : tagName)?.size -
                    40 +
                    'px'
                  : null
              "
            >
              {{ item?.smsText | checkValue }}
            </p>
          </div>
        </div>
      </td>

      <!-- price -->
      <td
        class="tw-px-1 sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [class.tw-hidden]="
          (cols | columnData : columnNames.price : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.price : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.price"
        [attr.order]="(cols | columnData : columnNames.price : tagName)?.order"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.price : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="number"
            [value]="item?.price"
          ></td-value>
        </div>
      </td>

      <!-- receiverCount -->
      <td
        class="tw-px-1 sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [class.tw-hidden]="
          (cols | columnData : columnNames.receiverCount : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.receiverCount : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.receiverCount"
        [attr.order]="
          (cols | columnData : columnNames.receiverCount : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.receiverCount : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            type="number"
            [value]="item?.receiverCount"
          ></td-value>
        </div>
      </td>

      <!-- resellerName -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.resellerName : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.resellerName : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.resellerName"
        [attr.order]="
          (cols | columnData : columnNames.resellerName : tagName)?.order
        "
        *ngIf="showReseller"
        class="msg-summary tw-text-center tw-cursor-pointer tw-py-1"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.resellerName : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <app-expand-text-click
            *ngIf="item?.resellerName"
            [smallText]="item?.resellerName | reseller"
            [placement]="'left'"
            data-toggle="tooltip"
          >
            <span
              class="tw-text-center"
              small-text
              [innerHTML]="item?.resellerName | reseller"
            ></span>
            <div full-text [innerHTML]="item?.resellerName | reseller"></div>
          </app-expand-text-click>

          <td-value
            *ngIf="!item?.resellerName"
            copyToClipboard
            [value]="item?.resellerName"
          ></td-value>
        </div>
      </td>

      <!-- senderNumber -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.senderNumber : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.senderNumber : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.senderNumber"
        [attr.order]="
          (cols | columnData : columnNames.senderNumber : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.senderNumber : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="text"
            [value]="item?.senderNumber"
          ></td-value>
        </div>
      </td>

      <!-- campaign title -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.title : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.title : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.title"
        [attr.order]="
          (cols | columnData : columnNames.title : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.title : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="text"
            [value]="item?.[columnNames.title]"
          ></td-value>
        </div>
      </td>

      <!-- sendType -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.sendType : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.sendType : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.sendType"
        [attr.order]="
          (cols | columnData : columnNames.sendType : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.sendType : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <span class="tw-text-sm" [sendTypeStyle]="item?.sendType">
            {{ item?.sendType | enumToText : SendTypesEnumValues }}</span
          >
        </div>
      </td>

      <!--send sub type-->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.sendSubType : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.sendSubType : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.sendSubType"
        [attr.order]="
          (cols | columnData : columnNames.sendSubType : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.sendSubType : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <span class="tw-text-sm" [sendTypeStyle]="item?.sendSubType">
            {{ item?.sendSubType | enumToText : SendSubTypesEnumValues }}</span
          >
        </div>
      </td>

      <!-- organizationName -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.organizationName : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.organizationName : tagName)
                ?.size + 'px'
            : null
        "
        [attr.name]="columnNames.organizationName"
        [attr.order]="
          (cols | columnData : columnNames.organizationName : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.organizationName : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="text"
            [value]="item?.organizationName"
          ></td-value>
        </div>
      </td>

      <!-- userName -->
      <td
        class="tw-px-1"
        [class.tw-hidden]="
          (cols | columnData : columnNames.userName : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.userName : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.userName"
        [attr.order]="
          (cols | columnData : columnNames.userName : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.userName : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            copyToClipboard
            type="text"
            [value]="item?.userName"
          ></td-value>
        </div>
      </td>

      <!-- smsParts -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.smsParts : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.smsParts : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.smsParts"
        [attr.order]="
          (cols | columnData : columnNames.smsParts : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.smsParts : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value
            class="tw-text-sm"
            type="number"
            [value]="item?.smsParts"
          ></td-value>
        </div>
      </td>

      <!-- status -->
      <td
        style="max-width: 200px"
        [class.tw-hidden]="
          (cols | columnData : columnNames.status : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.status : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.status"
        [attr.order]="(cols | columnData : columnNames.status : tagName)?.order"
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.status : tagName)?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <span
            [outBoxStatusStyle]="item?.status"
            [matTooltip]="item?.status | enumToText : OutBoxStatusEnumValues"
          >
            <i [outBoxStatusIcon]="item?.status"></i>
          </span>
        </div>
      </td>

      <!-- CreationLocation -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.creationLocation : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.creationLocation : tagName)
                ?.size + 'px'
            : null
        "
        [attr.name]="columnNames.creationLocation"
        [attr.order]="
          (cols | columnData : columnNames.creationLocation : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.creationLocation : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <span class="tw-text-sm">
            {{
              item?.creationLocation | enumToText : CreationLocationEnumValues
            }}</span
          >
        </div>
      </td>

      <!-- IsResend  -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.isResend : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.isResend : tagName)?.size + 'px'
            : null
        "
        [attr.name]="columnNames.isResend"
        [attr.order]="
          (cols | columnData : columnNames.isResend : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.isResend : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value type="boolean" [value]="item?.isResend"></td-value>
        </div>
      </td>

      <!-- isShouldNotResend  -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.isShouldNotResend : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.isShouldNotResend : tagName)
                ?.size + 'px'
            : null
        "
        [attr.name]="columnNames.isShouldNotResend"
        [attr.order]="
          (cols | columnData : columnNames.isShouldNotResend : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.isShouldNotResend : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value type="boolean" [value]="item?.isShouldNotResend"></td-value>
        </div>
      </td>

      <!-- isPostPaid  -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.isPostPaid : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.isPostPaid : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.isPostPaid"
        [attr.order]="
          (cols | columnData : columnNames.isPostPaid : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.isPostPaid : tagName)?.size +
                'px'
              : null
          "
          class="max-td-value"
        >
          <td-value type="boolean" [value]="item?.isPostPaid"></td-value>
        </div>
      </td>

      <!-- isVoiceMessage -->
      <td
        [class.tw-hidden]="
          (cols | columnData : columnNames.voiceMessageId : tagName)?.isHide
        "
        [style.width]="
          innerWidth > 1024
            ? (cols | columnData : columnNames.voiceMessageId : tagName)?.size +
              'px'
            : null
        "
        [attr.name]="columnNames.voiceMessageId"
        [attr.order]="
          (cols | columnData : columnNames.voiceMessageId : tagName)?.order
        "
      >
        <div
          [style.width]="
            innerWidth > 1024
              ? (cols | columnData : columnNames.voiceMessageId : tagName)
                  ?.size + 'px'
              : null
          "
          class="max-td-value"
        >
          <td-value type="boolean" [value]="item?.voiceMessageId"></td-value>
        </div>
      </td>

      <!-- sentDateTime -->
      <td
        [attr.name]="columnNames.sentDateTime"
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        [attr.position]="'left'"
        [attr.order]="99"
      >
        <td-value
          class="tw-text-sm"
          type="dateTimeWithSpace"
          [value]="item?.sentDateTime"
        ></td-value>
      </td>

      <!------------------------------- operations -------------------------------->
      <td
        class="sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8] operations-menu"
        [attr.position]="'left'"
        [attr.order]="99"
      >
        <div class="tw-flex-start *:tw-mx-1 *:tw-cursor-pointer">
          <a [matMenuTriggerFor]="menu">
            <i
              class="mdi mdi-dots-vertical text-navyBlue mdi-20px text-vertical"
            ></i>
          </a>

          <a
            *ngIf="item?.sendType != SendTypes.OTP"
            (click)="onDetail(item.scheduledMessageId, item.sendType)"
            [matTooltip]="'common.detail' | translate"
          >
            <i
              class="mdi-text-box-search-outline mdi mdi-20px tw-rounded-md tw-p-1 text-sky bg-bright-sky tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>

          <a
            (click)="deliveryStatusChart(item.scheduledMessageId)"
            [matTooltip]="'common.deliveryStatusStats' | translate"
          >
            <i
              class="mdi mdi-chart-arc mdi-20px tw-rounded-md tw-p-1 text-info bg-bright-info tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>

          <a
            [matTooltip]="'common.resendSMSByDeliverStatus' | translate"
            (click)="onShowResendByDeliveryStatus(item)"
          >
            <i
              class="mdi-email-sync mdi mdi-20px tw-rounded-md tw-p-1 text-teal bg-bright-teal tw-opacity-80 hover:tw-opacity-100"
            ></i>
          </a>
        </div>

        <mat-menu #menu="matMenu" xPosition="before">
          <!-- transactions button -->
          <div
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-warning border-bottom"
            (click)="onShowTransactions(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-swap-horizontal mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-warning mdi-rotate-90"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.transactions" | translate
            }}</span>
          </div>

          <!-- delete button -->
          <div
            *ngIf="userSession.organizationId() == 1"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-danger border-bottom"
            (click)="onDelete(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-trash-can-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.delete" | translate
            }}</span>
          </div>

          <!-- resend button -->
          <div
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-blue border-bottom"
            (click)="onSingleResend(item.scheduledMessageId, item?.sendType)"
          >
            <i
              class="mdi mdi-email-sync text-blue tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.resendSMS" | translate
            }}</span>
          </div>

          <!-- resend by delivery status button -->
          <div
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-info border-bottom"
            (click)="
              onShowReceivers(
                item.scheduledMessageId,
                item?.sentDateTime,
                item?.sendType
              )
            "
          >
            <i
              class="mdi mdi-account-group text-info tw-ml-[10px] ltr:tw-mr-[10px] mdi-20px"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.receivers" | translate
            }}</span>
          </div>

          <!-- resend detail button -->
          <div
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-slate border-bottom"
            (click)="onShowResendDetail(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-text-box-search-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-slate"
            ></i>
            <span class="mat-menu-title tw-font-medium text-slate">{{
              "common.resendDetail" | translate
            }}</span>
          </div>

          <!-- edit edit Receivers Status -->
          <div
            *ngIf="userSession.organizationId() == 1"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-info border-bottom"
            (click)="onEditReceiversDeliveryStatus(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-circle-edit-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.editReceiversStatus" | translate
            }}</span>
          </div>

          <!-- getNewDeliveryStatus -->
          <div
            *ngIf="userSession.organizationId() == 1"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onGetNewDeliveryStatus(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-circle-edit-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.getNewDeliveryStatus" | translate
            }}</span>
          </div>

          <!-- edit Status -->
          <div
            *ngIf="userSession.organizationId() == 1"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-navyBlue border-bottom"
            (click)="onEditStatus(item.scheduledMessageId, item?.status)"
          >
            <i
              class="mdi mdi-circle-edit-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.editStatus" | translate
            }}</span>
          </div>

          <!-- IsShouldNotResend -->
          <div
            *ngIf="userSession.organizationId() == 1"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-danger border-bottom"
            (click)="
              onIsShouldNotResend(
                item.scheduledMessageId,
                item?.isShouldNotResend
              )
            "
          >
            <i
              class="mdi mdi-message-bulleted-off mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.cancel" | translate
            }}</span>
          </div>

          <!-- StopSending -->
          <div
            *ngIf="item?.status == OutBoxStatus.IsBeingSent"
            mat-menu-item
            class="tw-flex tw-justify-center tw-items-center text-danger border-bottom"
            (click)="onStopSending(item.scheduledMessageId)"
          >
            <i
              class="mdi mdi-close mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-danger"
            ></i>
            <span class="mat-menu-title tw-font-medium">{{
              "common.stopSending" | translate
            }}</span>
          </div>
        </mat-menu>
      </td>
    </tr>
    }

    <tr
      [class.tw-hidden]="pageConfig.loading"
      class="tw-py-2 total-sum"
      *ngIf="!this.pageConfig.isEmpty"
    >
      <td
        class="tw-text-center !tw-py-3 tw-text-gray-600 sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        colspan="4"
      >
        {{ "common.currentPageTotalSum" | translate }}
      </td>
      <td
        class="tw-text-center tw-text-gray-800 tw-font-medium sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
      >
        <span class="max-td-value">
          {{ totalPriceCurrentPage | numberSeparator }}
        </span>
      </td>
      <td
        class="tw-text-center tw-text-gray-800 tw-font-medium sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
      >
        <span class="max-td-value">
          {{ totalReceiversCurrentPage | numberSeparator }}
        </span>
      </td>
      <td
        class="tw-text-center empty-td"
        [attr.colspan]="showReseller ? 17 : 16"
      ></td>
    </tr>

    <tr
      [class.tw-hidden]="pageConfig.loading"
      class="tw-py-2 total-sum"
      *ngIf="!this.pageConfig.isEmpty"
    >
      <td
        class="tw-text-center !tw-py-3 tw-text-gray-600 sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
        colspan="4"
      >
        {{ "common.totalSum" | translate }}
        <i
          *ngIf="!calcTotalApiLoading && (!totalPrice || !totalReceivers)"
          (click)="calcTotalApi()"
          class="mdi mdi-refresh mdi-20px text-hover-primary cursor-pointer"
          [matTooltip]="'common.getTotalCount' | translate"
        ></i>
        <span
          *ngIf="calcTotalApiLoading"
          class="spinner-border spinner-border-sm"
          role=" status"
          aria-hidden="true"
        ></span>
      </td>
      <td
        class="tw-text-center tw-text-gray-800 tw-font-medium sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
      >
        <span class="max-td-value">
          {{ totalPrice || "-" | numberSeparator }}
        </span>
      </td>
      <td
        class="tw-text-center tw-text-gray-800 tw-font-medium sticky-item lg:dark:!tw-bg-dark-300 lg:!tw-bg-[#f6f7f8]"
      >
        <span class="max-td-value">
          {{ totalReceivers || "-" | numberSeparator }}
        </span>
      </td>
      <td
        class="tw-text-center empty-td"
        [attr.colspan]="showReseller ? 17 : 16"
      ></td>
    </tr>
  </ng-container>
</app-page-template>

<!-- Detail -->
<ng-container *ngIf="isShowDetail">
  <app-outbox-messages-detail
    [model]="detailModel"
    [isShowPhonebookRecipient]="isShowPhonebookRecipientInDetail"
    (closePage)="
      isShowDetail = false; showParent = true; getParentQueryString()
    "
  >
  </app-outbox-messages-detail>
</ng-container>

<!-- Send Bulk Detail -->
<ng-container *ngIf="isShowSendBulkDetail">
  <app-outbox-messages-send-balk-detail
    [model]="detailModel"
    [scheduledMessageId]="scheduledMessageId"
    (closePage)="
      isShowSendBulkDetail = false; showParent = true; getParentQueryString()
    "
  >
  </app-outbox-messages-send-balk-detail>
</ng-container>

<!-- Send smart Detail -->
<ng-container *ngIf="isShowSendSmartDetail">
  <app-outbox-messages-send-smart-detail
    [model]="detailModel"
    [isShowSmartSmsRecipient]="isShowSmartSmsRecipientInDetail"
    [scheduledMessageId]="scheduledMessageId"
    (closePage)="
      isShowSendSmartDetail = false; showParent = true; getParentQueryString()
    "
  >
  </app-outbox-messages-send-smart-detail>
</ng-container>

<!-- ResendByDeliveryStatus -->
<ng-container *ngIf="isShowResendByDeliveryStatus">
  <app-resend-by-delivery-status
    [model]="resendByDeliveryStatusModel"
    [cpType]="cpType"
    [voiceMessageId]="voiceMessageId"
    [voiceMessageGroupId]="voiceMessageGroupId"
    [sendType]="selectedScheduledMessageSendType"
    [organizationId]="selectedOrganizationId"
    [userId]="selectedUserId"
    [organizationName]="selectedOrganizationName"
    [userName]="selectedUserName"
    [deliveryStatusEnumValues]="DeliveryStatusEnumValues"
    (closeFormPage)="getResendByDeliveryStatusResult($event)"
  >
  </app-resend-by-delivery-status>
</ng-container>

<!-- Resend detail -->
<ng-container *ngIf="isShowResendDetail">
  <app-resend-detail
    [modelWithPagination$]="resendDetailWithPagination$"
    [scheduledMessageId]="scheduledMessageId"
    (isClose)="closeResendDetail()"
  >
  </app-resend-detail>
</ng-container>

<!--------------------------------------- Audit --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    methodName="outBoxMessagesGetUserOutBoxMessagesAuditWithPagination"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!---------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="
      tabName == PageNames.currentUserOutboxMessages
        ? 'CurrentUserOutboxMessages'
        : tabName == PageNames.userOutboxMessages
        ? 'OrganizationOutboxMessages'
        : tabName == PageNames.resellerOutboxMessages
        ? 'CurrentResellerOutboxMessages'
        : 'UsersOutboxMessages'
    "
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
